module.exports = __webpack_public_path__ + "static/media/16-mobile.37ba9dea.jpg";